import React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

import { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteContact } from "../../redux/actions/contactsAction";
import { deleteCampaign } from "../../redux/actions/campaignsAction";
import { deleteForm } from "../../redux/actions/formsAction";

const DELETE_ACTIONS = {
  contact: deleteContact,
  contacts: deleteContact,
  campaign: deleteCampaign,
  campaigns: deleteCampaign,
  form: deleteForm,
  forms: deleteForm,
};

const ENTITY_LABELS = {
  contact: "contact",
  contacts: "contact",
  campaign: "campaign",
  campaigns: "campaign",
  form: "form",
  forms: "form",
};

const CONFIRM_MESSAGES = {
  form: "You are about to delete a form. Its existing submissions won't be deleted, but you'll lose access to them since they're only reachable through the form. Are you sure?",
  forms: "You are about to delete a form. Its existing submissions won't be deleted, but you'll lose access to them since they're only reachable through the form. Are you sure?",
};
const DEFAULT_CONFIRM_MESSAGE = "You are about to delete a record. Are you sure?";

export default function DeleteRecord({ collection, id, fetchRecords }) {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const entityLabel = ENTITY_LABELS[collection] || "record";

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setLoading(true);
    dispatch(DELETE_ACTIONS[collection](id))
      .then(() => {
        fetchRecords();
        setLoading(false);
        setIsModalOpen(false);
      })
      .catch((e) => {
        setLoading(false);
        console.log(e);
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        type="text"
        danger
        onClick={showModal}
        title={"Delete " + entityLabel}
        loading={loading}
      >
        <DeleteOutlined />
      </Button>
      {isModalOpen && (
        <Modal
          title={"Delete " + entityLabel}
          open={isModalOpen}
          okText="Yes"
          okType="danger"
          cancelText="No"
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <p>{CONFIRM_MESSAGES[collection] || DEFAULT_CONFIRM_MESSAGE}</p>
        </Modal>
      )}
    </>
  );
}
